<template>
	<div class="lang-selectors">
		<div
			class="lang-selection lang-selection-dropdwon"
			:class="getActiveStateClassname('de')"
			@click="changeLang('de')"
		>
			<img class="lang-flag-round" :src="flagDE" />
			<span>DE</span>
		</div>
		<div
			class="lang-selection lang-selection-dropdwon"
			:class="getActiveStateClassname('en')"
			@click="changeLang('en')"
		>
			<img class="lang-flag-round" :src="flagEN" />
			<span>EN</span>
		</div>
	</div>
</template>
<script>
import WikipediaFlagsDE from '@/assets/WikipediaFlags_DE.svg'
import WikipediaFlagsUS from '@/assets/WikipediaFlags_US.svg'

export default {
	name: 'LanguageSelectorEntryMobile',
	data() {
		return {
			flagDE: WikipediaFlagsDE,
			flagEN: WikipediaFlagsUS
		}
	},
	computed: {
		currentLocale() {
			return this.$i18n.locale
		},
		localeFlag() {
			if (this.currentLocale === 'de') {
				return this.flagDE
			} else {
				return this.flagEN
			}
		}
	},
	methods: {
		changeLang(lang) {
			if (this.currentLocale !== lang) {
				localStorage.setItem('lang', lang)
				location.reload()
			}
		},
		getActiveStateClassname(lang) {
			return this.currentLocale === lang ? 'active-lang' : ''
		}
	}
}
</script>

<style lang="stylus" scoped>
.lang-selectors {
	display: flex;
	align-items: center;
	justify-content: space-around;
	margin-top: 35px;
}
.lang-selection {
	display: flex;
	align-items: center;
	color: white;
	cursor: pointer;
}
.lang-flag-round {
	width: 22px;
	height: 22px;
	border-radius: 50%;
	margin-right: 6px;
	border: 1px solid rgba(255,255,255,0.3);
}

.lang-selection-dropdwon:hover {
    color: red;
	text-decoration: underline;
}
.active-lang {
	color: red;
}
</style>
